/**
 * app > store > cm
 *     > securityPolicy > threatPolicy
 *     > securityCenterPolicy 보안 센터 정책
 *
 * @created at 2021-10-15
 * @created by wj_tams_dev06
 */

import {SecutiryPolicyApiPrefix} from '~/utils/restApi'

const urlPrefix = `${SecutiryPolicyApiPrefix}/ext-dist/center-policy`

/**
 * NCSC_YARA_CATEGORY = 15001
 * NCSC_SNORT_CATEGORY = 15002
 * ECSC_YARA_CATEGORY = 15003
 * ECSC_SNORT_CATEGORY = 15004
 * TAMS_SNORT_CATEGORY = 15005
 * TAMS_YARA_CATEGORY = 15006
 */

const getRuleType = (val) => {
  return val === '0' ? 'snort' : 'yara'
}

export const state = () => ({
  storeReadOnly: true,
  // snort, yara 통합
  form: {
    ips_ext_pol_cntr_cate: 15001,
    ips_ext_pol_cntr_use_yn: 1,
    ips_ext_pol_cntr_sync_yn: 1,
    ips_ext_pol_cntr_risk: 4,
    ips_ext_pol_cntr_recv_term: 5,
    ips_ext_pol_cntr_send_term: 5,
    ips_ext_pol_cntr_desc: '',
    ips_ext_polcn_cm_device_id_list: [],
    ips_ext_pol_cntr_recv_server_url: '', // 필수
    ips_ext_pol_cntr_send_server_url: '',
    ips_ext_pol_cntr_institution_name: '', // 필수
    ips_ext_pol_cntr_institution_code: '', // 필수
    ips_ext_pol_cntr_equip_name: '', // 필수
    ips_ext_pol_cntr_equip_ip: '', // 필수
    ips_ext_pol_cntr_manager_code: '',
    ips_ext_pol_cntr_manager_ip: '',
    ips_ext_pol_cntr_key: '', // 필수
    ips_ext_pol_cntr_api_ver: ''
  },
  /** a. ruleTable tableData (top section) */
  activeRuleTab: '0',
  ruleData: [],
  ruleDataMode: 0,
  /** b. policy tableData (bottom section) */
  activePolicyTab: '0',
  activeCntrCate: 0,
  policyList: [],
  policyHistory: [],
  transmitHistory: [],
  isSync: 0,
  /** HistoryDiff */
  diffHistory: {
    countInfo: {},
    data: []
  },
  diffCountData: {},
  diffSummaryData: [],
  diffDetailData: []
})

export const mutations = {
  initPolicyData (state) {
    state.policyList = []
    state.policyHistory = []
    state.transmitHistory = []
  },
  setCategoryCate (state, payload) {
    state.activeCntrCate = payload
  },
  setReadOnly (state, payload) {
    state.storeReadOnly = payload
  },
  setActiveRuleTab (state, payload) {
    state.activeRuleTab = payload
  },
  setPolicyTab (state, payload) {
    state.activePolicyTab = payload
  },
  updateForm: (state, payload) => {
    if (_.get(payload, 'setAll')) {
      state[payload.target] = payload.val
    } else {
      state[payload.target][payload.key] = payload.val
    }
  },
  clearForm (state, payload) {
    Object.keys(state[payload.type]).forEach(key => {
      const val = state[payload.type][key]

      if (typeof val === 'string') {
        if (key === 'ips_ext_pol_cntr_api_ver') {
          state[payload.type][key] = '1.2'
        } else {
          state[payload.type][key] = ''
        }
      } else if (typeof val === 'number') {
        if ([
          'ips_ext_pol_cntr_recv_term',
          'ips_ext_pol_cntr_send_term'
        ].indexOf(key) > -1) {
          state[payload.type][key] = 5
        } else if (['ips_ext_pol_cntr_use_yn', 'ips_ext_pol_cntr_sync_yn'].indexOf(key) > -1) {
          state[payload.type][key] = 1
        } else if (key === 'ips_ext_pol_cntr_cate') {
          state[payload.type][key] = payload.cntrCate
        } else if (key === 'ips_ext_pol_cntr_risk') {
          state[payload.type][key] = 4
        } else {
          state[payload.type][key] = 0
        }
      } else if (Array.isArray(val)) {
        state[payload.type][key] = []
      }
    })
  },
  setRuleData (state, payload) {
    const cntrList = payload.ips_ext_pol_cntr_list
    const cate = {}
    const arr = []

    if (state.activeRuleTab === '0') {
      cntrList.forEach(el => {
        if (el.ips_ext_pol_cntr_cate === 15001 || el.ips_ext_pol_cntr_cate === 15002) {
          arr.push(el)
        }
      })
    } else {
      cntrList.forEach(el => {
        if (el.ips_ext_pol_cntr_cate === 15003 || el.ips_ext_pol_cntr_cate === 15004) {
          arr.push(el)
        }
      })
    }
    cate.ips_ext_pol_cntr_list = arr
    cate.ips_ext_pol_cntr_mode = payload.ips_ext_pol_cntr_mode
    state.ruleData = cate
  },
  setModeChange (state, payload) {
    state.ruleData.ips_ext_pol_cntr_mode = payload
  },
  setPolicyList (state, payload) {
    if (Array.isArray(payload)) {
      state.policyList = payload
    } else {
      state.policyList = [payload]
    }
  },
  setPolicyHistory (state, payload) {
    if (Array.isArray(payload)) {
      state.policyHistory = payload
    } else {
      state.policyHistory = [payload]
    }
  },
  setTransmitHistory (state, payload) {
    if (Array.isArray(payload)) {
      state.transmitHistory = payload
    } else {
      state.transmitHistory = [payload]
    }
  },
  setDiffHistory (state, payload) {
    const countInfo = {
      total: _.size(payload),
      add: 0,
      modify: 0,
      remove: 0
    }
    const obj = {
      1: 'add',
      2: 'modify',
      3: 'remove'
    }
    for (let i = 0; i < countInfo.total; i++) {
      const val = _.get(payload[i], 'ips_ext_dirct_rule_diff_type')

      countInfo[obj[val]] += 1
    }

    state.diffHistory = {
      countInfo: countInfo,
      data: payload
    }
  }
}

export const actions = {
  /** 1. GET 정책 Rule 데이터 [ snort (추후 버전: yara 추가 됨) ] */
  async fetchRuleData ({ state, commit }) {
    const loading = false
    const {code, result} = await this.$axios.$get(`${urlPrefix}`, {loading})
    if (code === 'ok') {
      commit('setRuleData', result)

      return true
    }
    return result
  },
  async fetchRuleDataById ({ state, commit }, payload) {
    const {code, result} = await this.$axios.$get(`${urlPrefix}/${payload.id}`)

    if (code === 'ok') {
      result.ips_ext_pol_cntr_id = payload.id
      commit('updateForm', {
        // target: ruleType === 'snort' ? 'snortRuleForm' : 'yaraRuleForm',
        target: 'form',
        val: result,
        setAll: true
      })
      return true
    }
    return result
  },
  async updateRuleData ({ state, commit }, payload) {
    const {code, result} = payload.action === 'add'
      ? await this.$axios.$post(`${urlPrefix}`, state.form)
      : await this.$axios.$put(`${urlPrefix}/${payload.id}`, state.form)

    if (code === 'ok') {
      return true
    }
    return result
  },
  async deleteRuleData ({ state, commit }, payload) {
    const {code, result} = await this.$axios.$delete(`${urlPrefix}/${payload.id}`)

    if (code === 'ok') {
      return true
    }
    return result
  },
  async updateRuleMode ({ state, commit }, payload) {
    const {code, result} = await this.$axios.$put(`${urlPrefix}/mode`, payload)
    if (code === 'ok') {
      return true
    }
    return result
  },
  async updateRuleUse ({ state, commit }, payload) {
    const {code, result} = await this.$axios.$put(`${urlPrefix}/${payload.id}/use`, payload.data)
    if (code === 'ok') {
      return true
    }
    return result
  },
  // 사용안함
  async updatePolicyDirectUse ({ state, commit }, payload) {
    const ruleType = getRuleType(state.activeRuleTab)
    const {code, result} = await this.$axios.$put(`${urlPrefix}/${ruleType}/policies`, payload.data)
    if (code === 'ok') {
      return true
    }
    return result
  },
  /** 2. 정책 데이터
   * payload.policy: snort || yara
   * tab: activePolicyTab
   */
  /** 1-a. 정책 목록 */
  async fetchPolicyList ({ commit }, payload) {
    const {code, result} = await this.$axios.$get(`${urlPrefix}/${payload.policy}`)
    commit('setPolicyTab', payload.tab)
    if (code === 'ok') {
      commit('setPolicyList', result)
      return true
    }
    return result
  },
  /** 1-b. 정책 History
   * snort | yara 룰에 대한 정책을
   * 주기 설정에 맞춰서 아까 위에 말씀드린 해당 기관에서 정책을 받아 배포하면 그 기록을 남기는 부분이 정책 history
  */
  async fetchPolicyHistory ({ commit }, payload) {
    const hasAlert = _.get(payload, 'muteAlert')
    const {code, result} = await this.$axios.$post(`${urlPrefix}/${payload.policy}`, payload.timeOption, {
      loading: true,
      successAlert: hasAlert
    })
    const tab = _.get(payload, 'tab')
    if (tab) {
      commit('setPolicyTab', tab)
    }

    if (code === 'ok') {
      commit('setPolicyHistory', result)
      return true
    }
    return result
  },
  /** 1-c. 전송 History */
  async fetchTransmitHistory ({ commit }, payload) {
    const hasAlert = _.get(payload, 'muteAlert')
    const {code, result} = await this.$axios.$post(`${urlPrefix}/${payload.policy}`, payload.timeOption, {
      loading: true,
      successAlert: hasAlert
    })
    commit('setPolicyTab', payload.tab)
    if (code === 'ok') {
      commit('setTransmitHistory', result)
      return true
    }
    return result
  },
  // 사용 안함
  async updateOptions ({ commit }, { policyType, centerPolicyType, params }) {
    try {
      let url = 'ext-dist/tams/policies'
      if (policyType === 'CENTER') {
        url = `ext-dist/center-policy/${centerPolicyType}/policies`
      }
      params = {items: params}
      const { code } = await this.$axios.$put(`${urlPrefix}/${url}`, params)
      if (code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  async updateMode ({ commit }, payload) {
    try {
      const centerMode = payload.mode
      const { code } = await this.$axios.$put(`${urlPrefix}/mode`, centerMode)
      if (code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  async fetchDiffHistory ({ commit, state }, payload) {
    const { code, result } = await this.$axios.$post(
      `${urlPrefix}/policy/history/diff/${payload.id}`,
      payload.diff,
      {
        loading: false,
        successAlert: false
      }
    )

    if (code === 'ok') {
      commit('setDiffHistory', result)
      return true
    }
    return result
  },
  async fetchDiffHistoryDetail () {
  },
  async finalCommand ({state}, payload) {
    const
      axiosConfig = (payload.command === 'apply') ? { applyMsg: true } : { cancelMsg: true }

    const {code, result} = await this.$axios.$put(`${urlPrefix}/${payload.command}`, void 0, axiosConfig)

    if (code === 'ok') {
      return true
    }
    return result
  }
}

export const getters = {
}
